import { saveAs } from "file-saver";
import JSZip from "jszip";

import { PdfReport } from "../models/pdf.report";
import { ExportReportExtension } from "./enums";

interface HandleGeneratePdfProps {
  data: PdfReport;
  setOpenModal?: (value: boolean) => void;
  exportFile?: boolean;
}

function contentToUint8Array(content: any): any {
  if (content === null || content === undefined) {
    throw new Error("Content cannot be null or undefined");
  }

  if (typeof content === "object") {
    return new Uint8Array(Object.values(content));
  }

  return new Uint8Array(content);
}

export const handleGeneratePdf = (props: HandleGeneratePdfProps) => {
  const { data, setOpenModal, exportFile } = props;

  try {
    let filename = data?.name;
    if (data?.type && !data?.name?.endsWith(data?.type)) {
      filename = `${data?.name}.${data?.type}`;
    }

    if (exportFile) {
      if (data && data?.content) {
        const uint8 = contentToUint8Array(data.content);
        const blob = new Blob([uint8.buffer]);
        saveAs(blob, `${filename}`);
      }
    } else if (data?.type === ExportReportExtension.PDF && data.content) {
      const uint8 = contentToUint8Array(data.content);
      const blob = new Blob([uint8.buffer], {
        type: "application/pdf",
      });

      const fileURL = URL.createObjectURL(blob);

      window.open(fileURL, "_blank")?.focus();

      // saveAs(blob, `${filename}`);
    } else if (data?.type === ExportReportExtension.ZIP && data.content) {
      const uint8 = contentToUint8Array(data.content);
      const zipBlob = new Blob([uint8.buffer]);

      // saveAs(zipBlob, `${filename}`);

      openAllReports(zipBlob);
    }

    if (setOpenModal) setOpenModal(false);
  } catch (error) {
    console.error("Error in generate PDF:", error);
  }
};

export const handleGenerateMultiplePdf = (data: PdfReport[]) => {
  for (const item of data) {
    handleGeneratePdf({ data: item });
  }
};

const openAllReports = async (blob: Blob) => {
  const zip = new JSZip();

  if (blob) {
    await zip.loadAsync(blob);
    const keys = Object.getOwnPropertyNames(zip.files);

    if (keys && keys?.length > 0) {
      await Promise.all(
        keys.map(async (key) => {
          const file = zip.files[key];

          if (file) {
            const uint8Array = await file.async("uint8array");

            const blob = new Blob([uint8Array.buffer], {
              type: "application/pdf",
            });

            const fileURL = URL.createObjectURL(blob);

            window.open(fileURL, "_blank")?.focus();
          }
        })
      );
    }
  }
};

interface ZipPDFReportsProps {
  pdfReports: PdfReport[];
  zipFileName: string;
}

export const zipPDFReports = async ({ pdfReports, zipFileName }: ZipPDFReportsProps) => {
  const zip = new JSZip();
  const counts: Record<string, number> = {};

  pdfReports.forEach((file) => {
    if (!file.content) return;

    const blob = new Blob([new Uint8Array(file.content).buffer], {
      type: "application/pdf",
    });

    let fileName = file?.name || "report.pdf";
    if (file?.type && !file?.name?.endsWith(file?.type)) {
      fileName = `${file?.name}.${file?.type}`;
    }

    const baseFileName = fileName?.endsWith(".pdf") ? fileName.slice(0, -4) : fileName || "report";
    const sameNameCounter = (counts[baseFileName] = (counts[baseFileName] || 0) + 1);
    const uniqueFileNames =
      sameNameCounter > 1 ? `${baseFileName} (${sameNameCounter - 1}).pdf` : `${baseFileName}.pdf`;

    zip.file(`${uniqueFileNames}`, blob);
  });

  zip.generateAsync({ type: "blob" }).then((blob) => saveAs(blob, `${zipFileName}.zip`));
};
